import CardHeader from "./CardHeader"
import ToolboxItems from "./ToolboxItems"

import sinpas from "../assets/logos/sinpaş.png"
import medas from "../assets/logos/medaş.png"
import kcetas from "../assets/logos/kcetas.png"
import akedas from "../assets/logos/akedas.png"
import aksa from "../assets/logos/aksa.png"
import iosb from "../assets/logos/iosb.png"
import iski from "../assets/logos/iski.png"
import tredas from "../assets/logos/tredas.png"
import aras from "../assets/logos/aras.png"
import kepsas from "../assets/logos/kepsas.png"
import oedas from "../assets/logos/oedas.png"
import coruh from "../assets/logos/coruh.png"
import firat from "../assets/logos/firat.png"
import akedas_perakende from "../assets/logos/akedas_perakende.png"
import eshot from "../assets/logos/eshot.png"
import igdas from "../assets/logos/igdas.png"

const TechStack = () => {
    const toolboxItems = [
        { iconType: sinpas, title: "Sinpaş" },
        { iconType: medas, title: "MEDAŞ" },
        { iconType: kcetas, title: "KCETAŞ" },
        { iconType: coruh, title: "ÇORUH" },
        { iconType: akedas, title: "AKEDAS" },
        { iconType: aksa, title: "Aksa" },
        { iconType: iosb, title: "İOSB" },
        { iconType: iski, title: "İSKİ" },
        { iconType: tredas, title: "TREDAŞ" },
        { iconType: aras, title: "ARAS" },
        { iconType: kepsas, title: "KEPSAS" },
        { iconType: oedas, title: "OEDAŞ" },
        { iconType: firat, title: "FIRAT" },
        { iconType: akedas_perakende, title: "AKEDAŞ PERAKENDE" },
        { iconType: eshot, title: "ESHOT" },
        { iconType: igdas, title: "İGDAŞ" }
    ]

    return (
        <>
            <div className="relative w-full py-12 overflow-hidden">
                <div className="absolute inset-0 text-white bg-gradient-to-r from-black/20 to-black/55 clip-diagonal"
                    style={{
                        background: "linear-gradient(217deg, #e9e9e940, #f5f5f596 70.71%), linear-gradient(127deg, #494949, #292929 70.71%), linear-gradient(336deg, #504343, #000000 70.71%)"
                    }}
                />
                <div className="relative z-10 flex justify-center items-center m-auto lg:max-w-[80%] bg-transparent mt-40 gap-8 px-3 sm:px-7">
                    <div className="w-full">
                        <div className="h-[325px] sm:h-[375px] p-0 md:col-span-3 lg:col-span-2">
                            <CardHeader
                                title="REFERENCES"
                                className=""
                            />
                            <ToolboxItems items={toolboxItems} className="" itemsWrapperClassName="animate-move-left [animation-duration:90s]" />
                            <ToolboxItems items={toolboxItems} className="mt-8" itemsWrapperClassName="animate-move-right [animation-duration:120s]" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default TechStack